export const LIGHT_SECTION_BACKGROUND = `
    radial-gradient(ellipse 70% 50% at 0% 0%, rgba(0, 163, 255, 0.07), transparent 55%),
    radial-gradient(ellipse 50% 40% at 100% 100%, rgba(0, 4, 53, 0.04), transparent 50%),
    linear-gradient(180deg, #f3f7fb 0%, #ffffff 55%, #f7f9fc 100%)
`

export const DARK_SECTION_BACKGROUND = "#000435"

export const pillButtonSx = {
    borderRadius: 999,
    textTransform: "none",
    fontWeight: 700,
}

export const overlineSx = {
    letterSpacing: "0.14em",
    color: "#00A3FF",
    fontWeight: 800,
}
